module.exports = __webpack_public_path__ + "resources/img/bg_cover_customer_m_v2.812c084dd088ccdf72562e5e4960b578.png";